import { Link } from 'react-router-dom';
import { allContent } from '@/mocks/siteData';

export default function FeaturedContent() {
  const featured = allContent.filter((item) => item.isHot).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
              <i className="ri-fire-line"></i>
              热门推荐
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              大家都在看
            </h2>
          </div>
          <Link
            to="/category/dianying"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={`在线观看${item.title} - 极速高清`}
                  title={`在线观看${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-black/60 backdrop-blur-sm text-white text-xs rounded-md">
                    {item.categoryName}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="flex items-center gap-1 px-2 py-1 bg-black/60 backdrop-blur-sm text-secondary-400 text-xs rounded-md">
                    <i className="ri-star-fill text-xs"></i>
                    {item.rating}
                  </span>
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center bg-primary-500/90 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                  {item.description}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span>{item.year}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span>{item.duration}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span>{item.views.toLocaleString()}次观看</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/dianying"
            className="inline-flex items-center gap-1 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}